export const customMessages = {
  'idFornecedor': {
    'string.base': '(Fornecedor) é um campo obrigatório',
    'string.empty': '(Fornecedor) é um campo obrigatório',
    'string.min': '(Fornecedor) deve ter no mínimo 3 caracteres',
    'string.max': '(Fornecedor) deve ter no máximo 100 caracteres',
    'any.required': '(Fornecedor) é um campo obrigatório',
  },
  'dataCompra': {
    'date.base': '(Data compra) deve ser uma data válida'
  },
};